// GAVION recruiting: the « Recrutement » client contract. Supabase: admin RPCs of 91_gavion_recruiting.sql
// (supabaseRecruitingClient); FakeRest demo and tests: localRecruitingClient (same codes, same shapes).
import type { AiReview } from "../aiReview";
import type {
  ApplicationDetail,
  ApplicationFilter,
  ApplicationNote,
  ApplicationStatus,
  ApplicationSummary,
  Posting,
  PostingInput,
} from "../domain";
import type { ManualCandidateInput } from "../manualCandidate";

export interface RecruitingClient {
  postings(): Promise<Posting[]>;
  /** id null = a new draft. Errors: invalid_posting (detail = the field), slug_taken, slug_locked (published: the slug never changes). */
  savePosting(id: number | null, input: PostingInput): Promise<Posting>;
  /** « Publier » / « Republier » (published), « Fermer » (closed). invalid_transition. */
  setPostingStatus(
    id: number,
    status: "published" | "closed",
  ): Promise<Posting>;
  /** A draft without application only (posting_not_deletable). */
  deletePosting(id: number): Promise<void>;
  applications(filter: ApplicationFilter): Promise<ApplicationSummary[]>;
  application(id: number): Promise<ApplicationDetail>;
  setApplicationStatus(
    id: number,
    status: ApplicationStatus,
  ): Promise<ApplicationDetail>;
  addNote(id: number, text: string): Promise<ApplicationNote>;
  /** The application, its notes, its CV (purge queue, then a best-effort direct removal). */
  deleteApplication(id: number): Promise<void>;
  /** The « Recrutement » menu count. */
  newCount(): Promise<number>;
  /**
   * Paramètres → Confidentialité: erase every application from this address (case-insensitive), their notes and files.
   * Errors: invalid_email, invalid_reason.
   */
  eraseByEmail(
    email: string,
    reason: "person_request" | "cai_order" | "other",
  ): Promise<{ count: number; purgeQueued: number }>;
  /** A short-lived signed URL (60 s) for « Ouvrir le CV » / « Ouvrir la lettre ». */
  cvUrl(path: string): Promise<string>;
  /**
   * GAVION manual-candidates « Ajouter un candidat »: the files go to job-cvs first (<new uid>/<random>.<ext>), then
   * the row (recruiting_add_application; its AI review is queued). Errors: invalid_application (detail = the field),
   * file_upload_failed (detail = cv / letter), forbidden.
   */
  addApplication(input: ManualCandidateInput): Promise<ApplicationDetail>;
  /** GAVION ai-hiring-review « Réévaluer »: the review back to pending. Errors: too_soon (within a minute), not_found. */
  requestReview(id: number): Promise<AiReview>;
}

export class RecruitingApiError extends Error {
  constructor(
    readonly code: string,
    readonly detail?: string,
  ) {
    super(code);
    this.name = "RecruitingApiError";
  }
}

export const RECRUITING_QUERY_KEY = ["gavion", "recruiting"] as const;
export const CV_LINK_SECONDS = 60;
